import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { getAdminToken, clearAdminToken } from "./aapi";

export default function AdminGuard() {
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = getAdminToken();
    if (!token) {
      setState("no");
      return;
    }
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => setState(data.role === "admin" ? "yes" : "no"))
      .catch(() => {
        clearAdminToken();
        setState("no");
      });
  }, []);

  if (state === "checking")
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/20 border-t-gold" data-testid="admin-auth-loading" />
      </div>
    );
  if (state === "no") return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
